
// 如文件名叫http.js
import axios from 'axios'

// 创建实例时设置配置的默认值
var instance = axios.create({
  // baseURL: 'https://smis.cn/SmisSaasServer',
  // baseURL: 'localhost',
  baseURL: 'https://smis.cn',

  timeout: 10000
});

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  /**
    1、比如添加token之类的请求头信息
    2、添加每次请求loading等
  */
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  /**
    1、集中处理响应数据（如错误码处理）
  */

  return response.data
}, function (error) {
  // 对响应错误做点什么
  //401
  if (error.response) {
    switch (error.response.status) {
      case 401:

        router.replace({
          path: 'login',
          query: { redirect: router.currentRoute.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
  }
  return Promise.reject(error);
});

export default instance



// WEBPACK FOOTER //
// ./src/http.js